export default __webpack_public_path__ + "f4edae2c632d9294738ec6cda74f729b.png";